const NotFound = () => {
  return (
    <>
      <h1>Not Found</h1>
      <p>There is nothing here.</p>
    </>
  )
}

export default NotFound
